import { render, staticRenderFns } from "./DataEntryForCategory.vue?vue&type=template&id=2e931b0e&scoped=true&"
import script from "./DataEntryForCategory.vue?vue&type=script&lang=js&"
export * from "./DataEntryForCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e931b0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e931b0e')) {
      api.createRecord('2e931b0e', component.options)
    } else {
      api.reload('2e931b0e', component.options)
    }
    module.hot.accept("./DataEntryForCategory.vue?vue&type=template&id=2e931b0e&scoped=true&", function () {
      api.rerender('2e931b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/CategoriesPage/DataEntryForCategory.vue"
export default component.exports